import { http } from 'lib/services/http';
import { platformAdminBaseUrl } from 'constants/apiUrls';

const PERMISSIONS_API_PATH = `${platformAdminBaseUrl}/permissions`;

// Get the available permissions macros
export const getPermissionsMacros = () => {
  return http.get(`${PERMISSIONS_API_PATH}/macros`);
};

// List the CRUD actions
export const getPermissionsActions = () => {
  return http.get(`${PERMISSIONS_API_PATH}/actions`);
};

// List the permission levels
export const getPermissionsLevels = () => {
  return http.get(`${PERMISSIONS_API_PATH}/levels`);
};
